module.exports = __webpack_public_path__ + "static/media/green_chips_game_end.2af9dcaa.svg";